import React from "react";

const ChatHistory = () => {
  return <div>ChatHistory</div>;
};

export default ChatHistory;
